import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Socials } from "./Socials";
import { PHONE_DISPLAY, PHONE_TEL, PHONE2_DISPLAY, PHONE2_TEL, EMAIL } from "@/lib/api";
import { useLang } from "@/lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  const ft = t.footer;
  const row = [...ft.words, ...ft.words];
  return (
    <footer data-testid="site-footer" className="relative overflow-hidden border-t border-white/10 bg-coal pb-28 md:pb-10">
      <div className="overflow-hidden border-b border-white/10 py-6">
        <div className="animate-marquee-fast flex w-max">
          {row.map((w, i) => (
            <span key={i} className="font-display flex items-center whitespace-nowrap px-6 text-2xl font-black uppercase text-white/[0.12] md:text-4xl">
              {w}<span className="ml-12 h-2 w-2 rotate-45 bg-brand2/70" />
            </span>
          ))}
        </div>
      </div>
      <div className="mx-auto grid max-w-[1440px] gap-10 px-5 pt-14 md:grid-cols-3 md:px-10">
        <div>
          <Logo testId="footer-logo" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-zinc-400">{ft.tagline}</p>
        </div>
        <div className="font-mono text-[12px] uppercase tracking-[0.16em] text-zinc-300">
          <a href={PHONE_TEL} className="block py-1 hover:text-brand">{PHONE_DISPLAY}</a>
          <a href={PHONE2_TEL} data-testid="footer-phone-2" className="block py-1 hover:text-brand">{PHONE2_DISPLAY}</a>
          <a href={`mailto:${EMAIL}`} className="block break-all py-1 normal-case tracking-normal hover:text-brand">{EMAIL}</a>
          <span className="block py-1 text-emerald-300">{ft.open}</span>
        </div>
        <div className="flex flex-col items-start gap-3 md:items-end">
          <Socials className="md:justify-end" />
          <span className="mt-2 font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400">© {new Date().getFullYear()} Smartkey Boston</span>
          <Link data-testid="footer-admin-link" to="/admin" className="font-mono text-[11px] uppercase tracking-[0.18em] text-zinc-400 hover:text-brand">{ft.owner}</Link>
        </div>
      </div>
    </footer>
  );
};
